// extracted by mini-css-extract-plugin
export default {"cross_icon_button":"styles_cross_icon_button__8klyP"};